@if(isParticipantFlow) {
    <ppl-timesheet-consumer-list></ppl-timesheet-consumer-list>
}

@else {
    <ppl-timesheet-provider-list></ppl-timesheet-provider-list>
}